var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.755 24.5C10.7506 24.5 9.77371 24.0195 9.07068 23.1838L3.64338 16.7187C2.77763 15.6857 2.78648 14.0226 3.66468 13.0052C4.54383 11.9869 5.95979 11.9972 6.82457 13.0293L11.7496 18.8965L23.174 5.28238C24.0415 4.2492 25.4557 4.23772 26.3357 5.25735C27.2129 6.27586 27.2227 7.93879 26.357 8.97197L14.4312 23.1824C13.7317 24.0171 12.7559 24.4989 11.755 24.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYes);
export default __webpack_public_path__ + "static/media/Yes.06e165a2fc6496565a7f6a2aed838889.svg";
export { ForwardRef as ReactComponent };